var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534.57 387.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e0ba56;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2.17px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.97,278.66H0v-8.92h33.93v8.92h-11.98v62.77h-9.97v-62.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.59,288.18v34.59c0,13.26-5.77,19.67-17.72,19.67s-16.76-6.83-16.76-19.52v-34.79c0-13.08,6.57-19.4,17.41-19.4s17.08,6.68,17.08,19.44ZM47.27,287.4v36.54c0,6.84,2.57,9.81,7.06,9.81,4.79,0,7.11-2.82,7.11-10.05v-36.34c0-6.5-2.19-9.86-7.14-9.86-4.65,0-7.03,3.1-7.03,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.21,308.78v32.65h-9.97v-71.69h14.66c11.25,0,17.43,4.49,17.43,16.95v2.96c0,10.48-4.21,13.78-7.57,15.01,4.5,1.85,6.85,5.03,6.85,14.7,0,6.07-.11,17.64.7,22.06h-9.66c-.97-4.39-.78-16.28-.78-21.41,0-8.97-1.25-11.24-8.2-11.24h-3.48ZM90.21,300.77h3.57c6.49,0,8.56-2.94,8.56-10.67v-2.77c0-5.96-1.47-9.57-8.36-9.57h-3.76v23.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.82,308.78v32.65h-9.97v-71.69h14.66c11.25,0,17.43,4.49,17.43,16.95v2.96c0,10.48-4.21,13.78-7.57,15.01,4.5,1.85,6.85,5.03,6.85,14.7,0,6.07-.11,17.64.7,22.06h-9.66c-.97-4.39-.78-16.28-.78-21.41,0-8.97-1.25-11.24-8.2-11.24h-3.48ZM130.82,300.77h3.57c6.49,0,8.56-2.94,8.56-10.67v-2.77c0-5.96-1.47-9.57-8.36-9.57h-3.76v23.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.84,307.86h-16.48v24.73h18.87l-1.29,8.84h-27.55v-71.69h27.37v8.92h-17.4v20.36h16.48v8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.11,320.72v4.31c0,5.93,1.98,9.17,6.69,9.17s6.38-3.93,6.38-9.93c0-7.99-1.8-10.75-9.71-16.74-7.98-6.05-12.15-9.83-12.15-20.42,0-9.29,2.9-18.48,15.58-18.45,12.6.03,15.06,8.48,15.06,16.82v3.62h-9.89v-3.36c0-5.4-1.01-8.76-5.36-8.76s-5.43,3.62-5.43,8.74c0,5.74,1.16,8.24,7.81,13,10.79,7.76,14.13,12.19,14.13,24.15,0,10.13-3.4,19.58-16.71,19.58s-16.38-8.08-16.38-17.53v-4.2h9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.07,298.17l-11.55,27.19c-4.85,11.3-9.94,16.86-18.72,16.86-10.76,0-15.32-7.96-15.32-19.43s4.49-15.57,13.97-23.06c6.88-5.42,8.75-8.07,8.75-15.29,0-4.66-.81-7.7-4.53-7.7-3.44,0-4.59,3.42-4.59,7.72,0,6.06.45,8.59,3.85,13.96l27.54,43.01h-11.15l-23.48-36.26c-4.69-7.24-6.02-11.14-6.02-19.8,0-10.47,4.89-16.49,13.77-16.49s13.6,5.44,13.6,15.56-3.05,13.85-13.01,21.43c-7.22,5.57-8.92,8.1-8.92,16.13,0,7.28,2.4,10.75,6.86,10.75s6.29-3.02,9.1-9.73l10.36-24.86h9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.31,278.66h-11.97v-8.92h33.93v8.92h-11.98v62.77h-9.97v-62.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.93,288.18v34.59c0,13.26-5.77,19.67-17.72,19.67s-16.76-6.83-16.76-19.52v-34.79c0-13.08,6.57-19.4,17.41-19.4s17.08,6.68,17.08,19.44ZM354.6,287.4v36.54c0,6.84,2.57,9.81,7.06,9.81,4.79,0,7.11-2.82,7.11-10.05v-36.34c0-6.5-2.19-9.86-7.14-9.86-4.65,0-7.03,3.1-7.03,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.54,308.78v32.65h-9.97v-71.69h14.66c11.25,0,17.43,4.49,17.43,16.95v2.96c0,10.48-4.21,13.78-7.57,15.01,4.5,1.85,6.85,5.03,6.85,14.7,0,6.07-.11,17.64.7,22.06h-9.66c-.97-4.39-.78-16.28-.78-21.41,0-8.97-1.25-11.24-8.2-11.24h-3.48ZM397.54,300.77h3.57c6.49,0,8.56-2.94,8.56-10.67v-2.77c0-5.96-1.47-9.57-8.36-9.57h-3.76v23.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M438.16,308.78v32.65h-9.97v-71.69h14.66c11.25,0,17.43,4.49,17.43,16.95v2.96c0,10.48-4.21,13.78-7.57,15.01,4.5,1.85,6.85,5.03,6.85,14.7,0,6.07-.11,17.64.7,22.06h-9.66c-.97-4.39-.78-16.28-.78-21.41,0-8.97-1.25-11.24-8.2-11.24h-3.48ZM438.16,300.77h3.57c6.49,0,8.56-2.94,8.56-10.67v-2.77c0-5.96-1.47-9.57-8.36-9.57h-3.76v23.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M495.18,307.86h-16.48v24.73h18.87l-1.29,8.84h-27.55v-71.69h27.37v8.92h-17.4v20.36h16.48v8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.44,320.72v4.31c0,5.93,1.98,9.17,6.69,9.17s6.38-3.93,6.38-9.93c0-7.99-1.8-10.75-9.71-16.74-7.98-6.05-12.15-9.83-12.15-20.42,0-9.29,2.9-18.48,15.58-18.45,12.6.03,15.06,8.48,15.06,16.82v3.62h-9.89v-3.36c0-5.4-1.01-8.76-5.36-8.76s-5.43,3.62-5.43,8.74c0,5.74,1.16,8.24,7.81,13,10.79,7.76,14.13,12.19,14.13,24.15,0,10.13-3.4,19.58-16.71,19.58s-16.38-8.08-16.38-17.53v-4.2h9.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.23,363.69h15.12v4.54h-9.45v4.97h8.87v4.51h-8.87v9.24h-5.67v-23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.06,363.69v23.26h-5.78v-23.26h5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.29,377.76v9.19h-5.64v-23.26h9.8c4.77,0,7.6,2.46,7.6,6.38,0,3.15-1.6,4.69-3.46,5.43,2.26.91,3.02,2.74,3.02,5.58v.72c0,2.1.1,3.96.28,5.14h-5.55c-.33-.97-.44-2.52-.44-5.19v-.68c0-2.53-.8-3.31-3.33-3.31h-2.27ZM110.29,373.46h2.66c1.99,0,3.39-.68,3.39-2.84,0-1.92-1.23-2.65-2.91-2.65h-3.14v5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.32,379.11c0-3.71.07-8.56.16-11.29h-.2c-.89,4.96-2.56,12.84-4.13,19.13h-4.75c-1.19-5.84-2.85-14.22-3.66-19.16h-.21c.18,2.72.28,7.55.28,11.56v7.6h-5.18v-23.26h8.39c1.15,4.68,2.57,11.82,3.06,15.26h.08c.51-3.47,2.26-10.22,3.54-15.26h8.14v23.26h-5.52v-7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.08,382.01l-1.21,4.93h-5.68l6.35-23.26h7.71l6.62,23.26h-6.01l-1.32-4.93h-6.45ZM163.55,377.37c-1-3.81-1.8-7.18-2.28-9.5h-.08c-.45,2.49-1.28,5.98-2.18,9.5h4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.46,363.69h5.78v18.72h9.51l-.58,4.54h-14.7v-23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.26,377.19h-9.35v5.24h10.41l-.66,4.51h-15.34v-23.26h15.33v4.55h-9.73v4.4h9.35v4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.96,386.95h-4.14c-.14-.68-.29-1.65-.34-2.31-1.18,2.09-3.34,2.72-5.98,2.72-6.17,0-8.97-5.07-8.97-11.83,0-7.21,3.67-12.21,10.45-12.21,6.2,0,8.61,3.7,9.01,7.19h-5.67c-.29-1.18-.94-2.77-3.55-2.77-3.18,0-4.26,3.26-4.26,7.76s1.15,7.47,4.29,7.47c2.65,0,3.48-1.92,3.48-4.4v-.37h-3.78v-4.45h9.48v13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.37,382.01l-1.21,4.93h-5.68l6.35-23.26h7.71l6.62,23.26h-6.01l-1.32-4.93h-6.45ZM250.85,377.37c-1-3.81-1.8-7.18-2.28-9.5h-.08c-.45,2.49-1.28,5.98-2.18,9.5h4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.58,363.69h5.78v18.72h9.51l-.58,4.54h-14.7v-23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.46,373.05v4.49h-8.88v-4.49h8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.51,379.41c-.53,3.93-2.99,7.94-9.28,7.94-7.47,0-9.84-5.37-9.84-12s3.23-12.04,10.06-12.04,8.8,4.46,8.96,7.84h-5.66c-.32-1.64-.81-3.42-3.41-3.42-3.03,0-3.97,3.18-3.97,7.61s.91,7.62,3.98,7.62c2.58,0,3.19-2.04,3.48-3.54h5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.54,375.19c0,7.08-3.06,12.16-10.43,12.16s-10.07-5.17-10.07-12.21c0-6.33,3.12-11.84,10.4-11.84s10.11,5.32,10.11,11.88ZM330.04,375.14c0,4.65,1.32,7.82,4.29,7.82,3.24,0,4.26-2.91,4.26-7.82,0-4.31-.99-7.43-4.33-7.43-3.06,0-4.21,2.95-4.21,7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.16,386.95v-23.26h6.99c5.15,12.27,6.15,14.82,6.45,15.87h.09c-.23-2.73-.29-6.61-.29-10.3v-5.57h5.25v23.26h-6.75c-5.55-13.61-6.34-15.71-6.64-16.61h-.06c.19,2.9.22,6.9.22,10.95v5.66h-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.23,368.24h-5.81v-4.55h17.39v4.55h-5.79v18.7h-5.79v-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.26,382.01l-1.21,4.93h-5.68l6.35-23.26h7.71l6.62,23.26h-6.01l-1.32-4.93h-6.45ZM397.74,377.37c-1-3.81-1.8-7.18-2.28-9.5h-.08c-.45,2.49-1.28,5.98-2.18,9.5h4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.47,363.69h9.48c5.23,0,7.37,2.75,7.37,5.96,0,2.81-1.47,4.14-2.88,4.72,1.74.71,3.63,2.35,3.63,5.55,0,4.38-3.16,7.03-8.27,7.03h-9.33v-23.26ZM416.74,372.72c2.11,0,2.98-.69,2.98-2.47s-1.1-2.48-2.82-2.48h-2.82v4.95h2.66ZM414.08,382.89h2.93c1.79,0,3.15-.84,3.15-3.06,0-2.06-1.06-3.12-3.46-3.12h-2.62v6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.38,363.69h5.78v18.72h9.51l-.58,4.54h-14.7v-23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.17,377.19h-9.35v5.24h10.41l-.66,4.51h-15.34v-23.26h15.33v4.55h-9.73v4.4h9.35v4.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 153.19,
    y: 126.8,
    width: 105.31,
    height: 105.31,
    rx: 10.43,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 278.41,
    y: 126.8,
    width: 105.31,
    height: 105.31,
    rx: 10.43,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 278.93,
    y: 1.08,
    width: 104.79,
    height: 104.79,
    rx: 10.38,
    ry: 10.38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "334.76 86.91 327.7 90.52 327.7 48.02 334.76 44.56 334.76 86.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.64,16.96c-1.43,2.09-2.88,4.19-4.37,6.3-1.2,1.71-2.39,3.39-3.59,5.06-.33-.82-.65-1.65-.98-2.47-1.62,1.06-3.26,2.11-4.92,3.16-17.83,11.17-35.8,19.66-53.31,26.09,1.26-.95,3.28-2.76,4.78-5.65.94-1.8,1.38-3.48,1.61-4.73,14.31-4.37,29.64-11.02,44.67-21.21,1.77-1.2,3.49-2.41,5.15-3.64-.32-.94-.63-1.89-.95-2.83,1.58.2,3.36.35,5.31.36,2.46.02,4.67-.17,6.58-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "320.49 83.46 313.43 87.09 313.43 57.08 311.18 55.9 320.49 51.41 320.49 83.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.98 69.63 341.83 73.26 341.83 43.08 339.73 42 348.98 37.47 348.98 69.63"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 153.19,
    y: 1.08,
    width: 105.31,
    height: 105.31,
    rx: 10.43,
    ry: 10.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.28,37.16v32.34h11.54v-32.34h-11.54ZM226.24,66.52h-4.38v-26.26h4.38v26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.1,37.16v32.34h11.54v-32.34h-11.54ZM190.07,66.52h-4.38v-26.26h4.38v26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.03,34.77v37.25h13.92v-37.25h-13.92ZM208.33,69.49h-5.12v-32.34l5.12.06v32.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.07,84.9h-9.09s-56.31,0-56.31,0h-8.98c1.51-.66,3.47-1.68,5.5-3.28,1.92-1.51,3.31-3.06,4.28-4.31h17.49v2.49s19.93.02,19.93.02l.03-2.49h17.47c.95,1.24,2.32,2.79,4.22,4.3,2.02,1.6,3.97,2.62,5.47,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.27,28.3c0,3.51-3.05,6.26-6.42,6.26-2.97,0-5.29-2.3-6.02-4.97h-14.89s0-2.41,0-2.41h-19.95v2.4s-14.97-.02-14.97-.02c-.73,2.68-3.23,5-6.2,5-3.31,0-6.43-2.7-6.42-6.26,0-3.35,2.77-6.18,6.22-6.25h61.78c3.71-.25,6.86,2.7,6.87,6.25Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter2);
export default __webpack_public_path__ + "static/media/logoFooter2.b80202adb85bb0fe4a31bedee7a6dc14.svg";
export { ForwardRef as ReactComponent };